.toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: 44px; /* WCAG 2.5.5 target size — matches nav links */
  min-width: 44px;
  padding: var(--space-2) var(--space-3);
  background: var(--color-bg-raised);
  color: var(--color-fg);
  font-family: var(--font-display);
  font-size: 0.625rem; /* 10px — matches nav link sizing */
  letter-spacing: var(--letter-spacing-display);
  text-transform: uppercase;
  white-space: nowrap;
  border: var(--border-width-2) var(--border-style) var(--color-border);
  box-shadow: var(--shadow-pixel-sm);
  cursor: pointer;
  user-select: none;
  transition: transform var(--transition-fast),
    box-shadow var(--transition-fast),
    background-color var(--transition-fast),
    color var(--transition-fast);
}

.toggle:hover,
.toggle:focus-visible {
  background: var(--color-accent);
  color: var(--color-bg);
  transform: translate(-1px, -1px);
  box-shadow: var(--shadow-pixel-md);
}

.toggle:active {
  transform: translate(1px, 1px);
  box-shadow: 0 0 0 0 var(--color-shadow);
}

.glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-body);
  font-size: 1.125rem; /* a touch larger so the sun/moon reads at small label sizes */
  line-height: 1;
}

.label {
  display: inline-flex;
  align-items: center;
}

@media (max-width: 600px) {
  /* Collapse to just the glyph on small screens to save horizontal space.
     The accessible name is on the button itself, so the visible text label is
     decorative and safe to hide. Tightened padding + min-width keep the button
     a compact square so it stops crowding the brand mark on the top row. */
  .toggle {
    gap: 0;
    min-width: 44px;
    padding: var(--space-2);
  }

  .label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}
